export const integrationsPaths = {
  absolute: '/:clientId/integrations',

  cloud: {
    absolute: '/:clientId/integrations/cloud',
    relative: 'cloud',
  },
  devices: {
    absolute: '/:clientId/integrations/devices',
    relative: 'devices',
  },
} as const;
